import { PROMOS } from '../../../utils/Config/Constants';

export const TABS_PROMO_TYPES = {
	AMOUNT: { value: PROMOS.discountTypes.amount, text: '$' },
	PERCENTAGE: { value: PROMOS.discountTypes.percentage, text: '%' }
};
